export class TaskTypeCustomComponent {
    Id: number | null;
    Tenant: number;
    ComponentName: string;
    DisplayName: string;
    ObjectTableCode: string;
}